import { render, staticRenderFns } from "./BenefitPopup.vue?vue&type=template&id=8a16baf8&scoped=true&"
import script from "./BenefitPopup.vue?vue&type=script&lang=js&"
export * from "./BenefitPopup.vue?vue&type=script&lang=js&"
import style0 from "./BenefitPopup.vue?vue&type=style&index=0&id=8a16baf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a16baf8",
  null
  
)

export default component.exports